export const PRESCREEN_INTERVIEW_DATE_PK = 'Prescreen';
export const PRESCREEN_INTERVIEW_DATE = Object.freeze({ pk_InterviewDate: PRESCREEN_INTERVIEW_DATE_PK });

export const getInterviewDatePk = (interviewDate) => {
  if (interviewDate == null) {
    return null;
  }

  if (typeof interviewDate === 'object') {
    return interviewDate.pk_InterviewDate != null ? interviewDate.pk_InterviewDate : null;
  }

  return interviewDate;
};

export const normalizeInterviewDatePk = (pk_InterviewDate) => {
  if (pk_InterviewDate == null || pk_InterviewDate === '') {
    return null;
  }

  if (
    typeof pk_InterviewDate === 'string' &&
    pk_InterviewDate.toUpperCase() === PRESCREEN_INTERVIEW_DATE_PK.toUpperCase()
  ) {
    return PRESCREEN_INTERVIEW_DATE_PK;
  }

  const numericPk = Number(pk_InterviewDate);
  return Number.isNaN(numericPk) ? pk_InterviewDate : numericPk;
};

export const isPrescreenInterviewDate = (interviewDate) => {
  const pk_InterviewDate = normalizeInterviewDatePk(getInterviewDatePk(interviewDate));
  return pk_InterviewDate === PRESCREEN_INTERVIEW_DATE_PK;
};

export const findInterviewDateInCollection = (interviewDate, interviewDates = []) => {
  if (!Array.isArray(interviewDates) || interviewDates.length === 0) {
    return null;
  }

  const normalizedPk = normalizeInterviewDatePk(getInterviewDatePk(interviewDate));
  if (normalizedPk == null) {
    return null;
  }

  return (
    interviewDates.find((item) => {
      return normalizeInterviewDatePk(item && item.pk_InterviewDate) === normalizedPk;
    }) || null
  );
};

export const normalizeInterviewDate = (interviewDate, interviewDates = []) => {
  if (interviewDate == null || interviewDate === '') {
    return null;
  }

  const matchingDate = findInterviewDateInCollection(interviewDate, interviewDates);
  if (matchingDate) {
    return matchingDate;
  }

  if (isPrescreenInterviewDate(interviewDate)) {
    if (typeof interviewDate === 'object' && interviewDate.pk_InterviewDate === PRESCREEN_INTERVIEW_DATE_PK) {
      return interviewDate;
    }

    return { ...PRESCREEN_INTERVIEW_DATE };
  }

  if (typeof interviewDate === 'object') {
    const normalizedPk = normalizeInterviewDatePk(interviewDate.pk_InterviewDate);
    if (normalizedPk === interviewDate.pk_InterviewDate || normalizedPk == null) {
      return interviewDate;
    }

    return {
      ...interviewDate,
      pk_InterviewDate: normalizedPk,
    };
  }

  const normalizedPk = normalizeInterviewDatePk(interviewDate);
  return normalizedPk == null ? null : { pk_InterviewDate: normalizedPk };
};

export const serializeInterviewDateForRoute = (interviewDate) => {
  const pk_InterviewDate = normalizeInterviewDatePk(getInterviewDatePk(interviewDate));
  return pk_InterviewDate == null ? '' : String(pk_InterviewDate);
};
